<template>
  <div id="KnowledgePreview" :class="(knowledgeDetail.fileSuffix === 'xls' || knowledgeDetail.fileSuffix === 'xlsx') ? 'xlsKnowledgeHeight' : ''">
    <intelligent-summary
        v-show="showSummary && !main_isLishi"
        :knowledgeId="knowledgeDetail.knowledgeId"
        @closeSummary="closeSummary"
    ></intelligent-summary>
    <!-- 对话记录音频播放：当为TXT预览且thirdExt满足条件时，显示音频播放器列表 -->
    <div v-if="fileType === 'TXT' && isConversationRecord" class="conversation-audio">
      <div class="audio-header">对话音频</div>
      <div class="audio-list">
        <div class="audio-item" v-for="(u, idx) in audioList" :key="idx">
          <span class="audio-label">音频{{ idx + 1 }}</span>
          <audio :src="u" controls preload="none"></audio>
        </div>
      </div>
    </div>
    <vue-excel :src="src" v-if="fileType === 'EXCEL'" :editType="editType"></vue-excel>
    <vue-pdf :src="src" v-else-if="fileType === 'PDF'" :editType="editType"></vue-pdf>
    <vue-doc :src="src" v-else-if="fileType === 'DOC'" :editType="editType"></vue-doc>
    <vue-txt :src="src" v-else-if="fileType === 'TXT'" :editType="editType"></vue-txt>
    <!-- 音频文件预览 -->
    <div v-else-if="isAudioFile" class="audio-preview-container">
      <div class="audio-player-wrapper">
        <div class="audio-info">
          <i class="iconfont guoran-tongyichicun-shengyin audio-icon"></i>
          <span class="audio-name">{{ knowledgeDetail.name }}</span>
        </div>
        <audio :src="decodedAudioSrc" controls controlsList="nodownload" preload="metadata" class="audio-player">
          您的浏览器不支持音频播放
        </audio>
      </div>
      <!-- 音频转写文本内容 -->
      <div class="audio-text-content" v-if="audioHtmlContent" @click="getImg($event, audioHtmlContent)" v-html="audioHtmlContent"></div>
    </div>
    <file-preview
        v-else
        ref="filePreview"
        :url="src"
        :fileType="fileType"
        :knowledgeItem="knowledgeDetail"
        :hiddenToolbar="true">
    </file-preview>
    <img-view :url-list="imgList" @closeViewer="closeViewer" v-if="previewImage"></img-view>
    <div class="reviewContainer" id="reviewContainer">
      <div class="noOneLikeStatus"
           :class="comment.likeNumber > 0 ? 'likeStatus1' : 'likeStatus2'"
      >
        <div class="likeBtn" @click="likeKnowledge">
          <i class="iconfont guoran-dianzan"></i>
        </div>
        <div class="likeText" :class="$i18n.locale === 'en' ? 'likeTextEn' : ''">
          <span v-if="comment.likeNumber == 0">{{ $t('versionManage.emptyLike') }}</span>
          <span v-else>{{comment.likeNumber}}{{ $t('versionManage.numLike') }}</span>
        </div>
        <div class="likeList">
          <div
               v-for="(item,index) in comment.likeList"
               :key="index"
          >
            <el-tooltip placement="top" effect="dark">
              <div slot="content">
                {{ item.name }}
              </div>
              <el-avatar :size="24" :src="item.avatar" v-if="item.avatar"></el-avatar>
              <span v-else-if="item.name" class="likeItem">{{(item.name).substr(-2)}}</span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="commentList" v-if="comment.list.length">
        <div class="header">{{ $t('versionManage.fullTextComments') }}</div>
        <comment-com
            :commentList="comment.list"
            :replyPageIndex="replyPageIndex"
            :replyPageSize="replyPageSize"
            :clientUser="clientUser"
            @replyComment="replyComment"
            @updateComment="updateComment"
            @deleteReply="deleteReply"
            @loadMore="loadMore"
        ></comment-com>
        <div class="loadMoreComment"
             v-if="totalCount - ((pageIndex + 1) * pageSize) > 0"
             @click="loadMoreComment"
        >
          <span>{{ $t('versionManage.loadMore') }}</span>
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
      <ckeditor-input
          @sendComment="sendComment"
          @cancelInput="cancelInput"
          ref="ckeditorParentInput"
          :knowledgeComment="true"
          :parentCommentId="parentCommentId"
          :replyItem="replyItem"
      ></ckeditor-input>
    </div>
    <div class="floating" @click="scrollView" :class="isShowHistoryVersion ? 'floating-1' : 'floating-2'">
      <div class="ksCOFC">
        <i class="iconfont " :class="goTop ? 'guoran-shangyi' : 'guoran-tongyichicun-14-06-pingjiaguanli'"></i>
      </div>
    </div>
  </div>
</template>

<script>
import filePreview from "@/components/FilePreview";
import CommentCom from "@/components/knowledgePreview/comment";
import { requestUrl } from "@/http/requestUrl";
import VueExcel from "@/components/preview/excel/vueExcel";
import VuePdf from "@/components/preview/pdf/vuePdf";
import VueDoc from "@/components/preview/doc/vueDoc";
import VueTxt from "@/components/preview/txt/vueTxt";
import CkeditorInput from "@/components/knowledgePreview/ckeditorInput";
import ImgView from "@/components/imgView";
import IntelligentSummary from "@/components/intelligentSummary";

export default {
  name: "KnowledgePreview",
  data(){
    return{
      previewUrl:"",
      comment:{
        likeNumber:0,
        list:[],
        likeList:[],
        like:false
      },
      goTop:false,
      observer:null,
      replyItem:null,
      pageIndex:0,
      pageSize:20,
      replyPageIndex:{},
      replyPageSize:5,
      commentId:null,
      totalCount:0,
      parentCommentId:"",
      clientUser:null,
      showSummary:true,
      // 对话记录音频
      audioUrls: [],
      signedAudioUrls: [],
      signingAudios: false,
      // 当 props.knowledgeDetail 缺少 thirdExt 时，兜底从 /knowledge-api/knowledge/detail/{knowledgeId} 获取
      extraThirdExt: null,
      // 音频文件的 html_result 内容
      audioHtmlContent: '',
      imgList: [],
      previewImage: false
    }
  },
  components:{
    IntelligentSummary,
    CkeditorInput,
    VueTxt,
    VueDoc,
    VuePdf,
    VueExcel,
    CommentCom,
    filePreview,
    ImgView
  },
  computed: {
    effectiveThirdExt() {
      const thirdExt = (this.knowledgeDetail && this.knowledgeDetail.thirdExt) || this.extraThirdExt;
      return thirdExt || null;
    },
    isConversationRecord() {
      const thirdExt = this.effectiveThirdExt;
      if (!thirdExt) return false;
      const hasInfo = !!thirdExt.refThirdInfo;
      const isType1 = String(thirdExt.refThirdType) === '1';
      return hasInfo && isType1;
    },
    audioList() {
      return this.signedAudioUrls && this.signedAudioUrls.length
        ? this.signedAudioUrls
        : (this.audioUrls || []);
    },
    // 判断是否是音频文件
    isAudioFile() {
      const audioFormats = ['mp3', 'wav', 'm4a', 'aac', 'flac', 'ogg', 'amr'];
      const fileSuffix = this.knowledgeDetail?.fileSuffix?.toLowerCase();
      return audioFormats.includes(fileSuffix);
    },
    // 解码音频 URL（从 base64 解码）
    decodedAudioSrc() {
      if (!this.src || !this.isAudioFile) return '';
      try {
        // 尝试 base64 解码
        const decoded = atob(this.src);
        return decoded;
      } catch (e) {
        // 如果不是 base64 编码，直接返回原 URL
        return this.src;
      }
    }
  },
  props:{
    knowledgeDetail:{
      type:Object,
      default(){
        return {}
      }
    },
    src:{
      type:String,
      default:""
    },
    fileType:{
      type:String,
      default:""
    },
    isShowHistoryVersion:{
      type:Boolean,
      default:false
    },
    editType:{
      type:String,
      default:""
    }
  },
  methods:{
    // 获取音频文件的 html_result 内容
    async getAudioHtmlContent() {
      try {
        const kid = this.$route && this.$route.query && this.$route.query.knowledgeId;
        if (!kid) {
          console.log('[KnowledgePreview] getAudioHtmlContent no knowledgeId');
          return;
        }
        const url = `/knowledge-api/correction/knowledge-parse-info/${kid}`;
        console.log('[KnowledgePreview] getAudioHtmlContent GET', url);
        const res = await this.$http.get(url);
        if (res.data.code === "0" && res.data.data) {
          const htmlRes = res.data.data?.extractChunkInfo?.docChunkData?.html_result;
          if (htmlRes) {
            console.log('[KnowledgePreview] html_result found:', htmlRes);
            // 获取 HTML 内容
            const htmlResponse = await this.$http.get(htmlRes);
            this.audioHtmlContent = htmlResponse.data;
            console.log('[KnowledgePreview] audioHtmlContent loaded');
          }
        }
      } catch (e) {
        console.warn('[KnowledgePreview] getAudioHtmlContent error:', e);
      }
    },
    // 解析thirdExt信息
    parseThirdInfo() {
      const thirdExt = this.effectiveThirdExt;
      if (!thirdExt || !thirdExt.refThirdInfo) return null;
      try {
        const parsed = typeof thirdExt.refThirdInfo === 'string'
          ? JSON.parse(thirdExt.refThirdInfo)
          : thirdExt.refThirdInfo;
        console.log('[KnowledgePreview] parseThirdInfo parsed:', parsed);
        return parsed;
      } catch (e) {
        console.warn('refThirdInfo JSON parse error:', e);
        return null;
      }
    },
    // 当 thirdExt 缺失时，尝试通过知识详情接口补齐 thirdExt
    async fetchThirdExtIfMissing() {
      try {
        if (this.effectiveThirdExt) {
          console.log('[KnowledgePreview] fetchThirdExtIfMissing skipped, already have thirdExt');
          return;
        }
        const kid = this.$route && this.$route.query && this.$route.query.knowledgeId;
        if (!kid) {
          console.log('[KnowledgePreview] fetchThirdExtIfMissing no knowledgeId in route');
          return;
        }
        const url = `/knowledge-api/knowledge/detail/${kid}`;
        console.log('[KnowledgePreview] fetchThirdExtIfMissing GET', url);
        const res = await this.$http.get(url);
        const thirdExt = res && res.data && res.data.data && res.data.data.thirdExt;
        if (thirdExt) {
          this.extraThirdExt = thirdExt;
          console.log('[KnowledgePreview] fetchThirdExtIfMissing got thirdExt:', thirdExt);
          // 若是对话记录并为TXT预览，准备音频
          if (this.fileType === 'TXT' && this.isConversationRecord) {
            this.prepareConversationAudios();
          }
        } else {
          console.log('[KnowledgePreview] fetchThirdExtIfMissing no thirdExt in response');
        }
      } catch (e) {
        console.warn('[KnowledgePreview] fetchThirdExtIfMissing error:', e);
      }
    },
    // 准备音频播放（签名）
    async prepareConversationAudios() {
      try {
        console.log('[KnowledgePreview] prepareConversationAudios start. fileType:', this.fileType, 'isConversationRecord:', this.isConversationRecord);
        this.signedAudioUrls = [];
        this.audioUrls = [];
        const thirdExt = this.effectiveThirdExt;
        console.log('[KnowledgePreview] thirdExt:', thirdExt);
        if (!thirdExt || !thirdExt.originAudioUrls) {
          console.log('[KnowledgePreview] no originAudioUrls found.');
          return;
        }
        // originAudioUrls 可能是字符串化的数组
        let arr = [];
        try {
          arr = typeof thirdExt.originAudioUrls === 'string'
            ? JSON.parse(thirdExt.originAudioUrls)
            : (Array.isArray(thirdExt.originAudioUrls) ? thirdExt.originAudioUrls : []);
        } catch (e) {
          console.warn('originAudioUrls JSON parse error:', e);
          arr = [];
        }
        console.log('[KnowledgePreview] originAudioUrls parsed:', arr);
        if (!Array.isArray(arr) || arr.length === 0) {
          console.log('[KnowledgePreview] originAudioUrls empty after parse.');
          return;
        }
        this.audioUrls = arr;
        this.signingAudios = true;
        // 使用已有的预览签名接口
        const previewApi = requestUrl.preview.previewUrl + '?isVersionManage=1&needEncrypt=false';
        console.log('[KnowledgePreview] signing previewApi:', previewApi);
        const tasks = arr.map(async (rawUrl) => {
          console.log('[KnowledgePreview] sign url:', rawUrl);
          try {
            const resp = await this.$http.post(previewApi, { fileInOssPath: rawUrl });
            console.log('[KnowledgePreview] sign response for', rawUrl, ':', resp && resp.data);
            if (resp && resp.data && (resp.data.code === '0' || resp.data.code === 0) && resp.data.data) {
              return resp.data.data;
            }
            // 回退到原始链接（尽量不影响原有逻辑）
            return rawUrl;
          } catch (e) {
            console.warn('[KnowledgePreview] sign error for', rawUrl, e);
            // 失败时回退原始链接
            return rawUrl;
          }
        });
        const signed = await Promise.all(tasks);
        this.signedAudioUrls = signed.filter(Boolean);
        console.log('[KnowledgePreview] signedAudioUrls:', this.signedAudioUrls);
      } finally {
        this.signingAudios = false;
        console.log('[KnowledgePreview] prepareConversationAudios end. signingAudios:', this.signingAudios);
      }
    },
    getCommentList(commentId){
      let url = requestUrl.comment.commentList;
      let obj = {
        "knowledgeId":this.knowledgeDetail.knowledgeId,
        "commentId": commentId,
        "pageIndex": this.pageIndex,
        "pageSize": this.pageSize,
        "replyPageIndex":0,
        "replyPageSize": this.replyPageSize
      }
      if (commentId){
        obj.knowledgeId = null;
        if (!this.replyPageIndex[commentId]){
          this.replyPageIndex[commentId] = 0;
        }
        obj.replyPageIndex = this.replyPageIndex[commentId];
      }
      this.$http.post(url,obj).then(res => {
        if (res.data.code == 0 && res.data.data){
          let rows = res.data.data.rows;
          let data = rows.map(da => {
            this.$set(da,'view',true);
            this.$set(da,'editing',false);
            if (!commentId){
              if (!this.replyPageIndex[da.commentId]){
                this.replyPageIndex[da.commentId] = 0;
              }
              this.$set(da,'replyPageIndex',this.replyPageIndex[da.commentId])
            }
            if (da.comments && da.comments.rows){
              da.comments.rows = da.comments.rows.map(com => {
                this.$set(com,'view',true);
                this.$set(com,'editing',false);
                return com
              })
            }
            return da
          })
          // this.comment.list = [];
          // this.comment.list = data;
          if (commentId){
            this.comment.list.forEach(item => {
              this.$set(item,'replyPageIndex',this.replyPageIndex[commentId])
              if (item.commentId === commentId){
                console.log('totalCount',res.data.data.totalCount)
                if (!item.comments){
                  this.$set(item,'comments',{
                    rows:[],
                    totalCount:0
                  })
                }
                item.comments.totalCount = res.data.data.totalCount;
                if (this.replyPageIndex[commentId] == 0){
                  item.comments.rows = data;
                } else {
                  //添加回复时若超出每页数据时会默认push到最后，所以分页加载时需要将数据过滤掉
                  let ids = item.comments.rows.map(row => row.commentId)
                  let newData = data.filter(item => ids.indexOf(item.commentId) == -1)
                  let count = newData.length - data.length;
                  item.comments.totalCount = item.comments.totalCount - count;
                  item.comments.rows = item.comments.rows.concat(newData);
                  // item.comments.rows = item.comments.rows.concat(data);
                }
              }
            })
          } else {
            this.totalCount = res.data.data.totalCount;
            if (this.pageIndex === 0){
              this.comment.list = [];
            }
            this.comment.list = this.comment.list.concat(data);
            // this.$set(this.comment,'list',data);
          }
          console.log('data',this.comment.list)
        }
      })
    },
    //发送评论
    sendComment(htmlContent){
      const reg = /th:text="(.*?)"/g;
      const regex = new RegExp('<span' + '[^>]*>(.*?)<\/' + 'span>', 'g');
      const arr = [];
      let matched = null;
      let nameMatched = null;
      while ((matched = reg.exec(htmlContent)) !== null) {
        let obj ={
          memberId:matched[1],
          mainId:sessionStorage.getItem('_mainId'),
          uid:""
        }
        if ((nameMatched = regex.exec(htmlContent)) !== null){
          if (nameMatched[1]){
            obj.name = nameMatched[1].replace('@',"")
          }
        }
        arr.push(obj);
      }
      let url = requestUrl.comment.saveComment;
      let obj = {
        htmlContent:htmlContent,
        atUserList:arr
      }
      //replyItem有值表示是回复某个评论或回复
      if (this.replyItem){
        url = requestUrl.comment.replyComment
        obj.commentId = this.replyItem.commentId;
        this.replyPageIndex[obj.commentId] = 0;
      } else {
        obj.knowledgeId = this.knowledgeDetail.knowledgeId
      }
      this.$http.post(url,obj).then(res => {
        if (res.data.code == 0){
          this.$message({
            message:"评论成功",
            type:"success"
          })
          if (this.replyItem){
            //以下处理是二级评论过多的时候直接push到该评论的回复的最后，防止分页导致数据未显示
            let obj = {
              commentId : res.data.data.commentId,
              commentatorName:sessionStorage.getItem('realname'),
              commentatorUid:sessionStorage.getItem('_uid'),
              htmlContent,
              createdAt:new Date().format('yyyy-MM-dd hh:mm:ss'),
              updatedAt:new Date().format('yyyy-MM-dd hh:mm:ss'),
              comments:null,
              knowledgeId:"",
              like: false,
              likeCount: 0,
              likes: [],
              parentId:this.replyItem.commentId,
              parentUserName:this.replyItem.commentatorName,
              view:true,
              commentatorAvatar:sessionStorage.getItem('profilePhoto')
            }
            let parentId = "";
            if (this.parentCommentId){
              parentId = this.parentCommentId;
            } else {
              parentId = this.replyItem.commentId
            }
            this.comment.list.forEach(item => {
              if (item.commentId === parentId){
                if (!item.comments){
                  this.$set(item,'comments',{
                    rows:[],
                    totalCount:0
                  })
                }
                item.comments.rows.push(obj)
                item.comments.totalCount += 1;
              }
            })
          } else {
            this.getCommentList('')
          }
          this.replyItem = null;
          this.parentCommentId = "";
          this.$refs.ckeditorParentInput.htmlContent = '';
        }
      })
    },
    updateComment(htmlContent,item){
      const reg = /th:text="(.*?)"/g;
      const regex = new RegExp('<span' + '[^>]*>(.*?)<\/' + 'span>', 'g');
      const arr = [];
      let matched = null;
      let nameMatched = null;
      while ((matched = reg.exec(htmlContent)) !== null) {
        let obj ={
          memberId:matched[1],
          mainId:sessionStorage.getItem('_mainId'),
          uid:""
        }
        if ((nameMatched = regex.exec(htmlContent)) !== null){
          if (nameMatched[1]){
            obj.name = nameMatched[1].replace('@',"")
          }
        }
        arr.push(obj);
      }
      let url = requestUrl.comment.updateReply;
      let obj = {
        htmlContent:htmlContent,
        commentId:item.commentId,
        atUserList:arr
      }
      this.$http.put(url,obj).then(res => {
        if (res.data.code == 0){
          this.$message({
            message:"编辑评论成功",
            type:"success"
          })
          item.htmlContent = htmlContent
          // this.getCommentList();
          item.editing = false;
          item.view = true;
          item.updatedAt = new Date().format('yyyy-MM-dd hh:mm:ss')
        }
      })
    },
    //删除评论/回复
    deleteReply(item,parentCommentId){
      let url = requestUrl.comment.removeComment + item.commentId;
      this.$http.delete(url).then(res => {
        if (res.data.code == 0){
          this.$message({
            message:"删除成功",
            type:"success",
          })
          this.replyPageIndex[parentCommentId] = 0;
          this.pageIndex = 0;
          this.getCommentList();
        }
      })
    },
    cancelInput(){
      this.replyItem = null;
      this.parentCommentId = "";
      this.$refs.ckeditorParentInput.htmlContent = '';
    },
    //回复评论
    replyComment(item,parentCommentId){
      console.log('item',item,parentCommentId)
      this.replyItem = item;
      this.parentCommentId = parentCommentId;
      setTimeout(() => {
        this.$refs.ckeditorParentInput.currentEditor.editing.view.focus();
        let target = document.getElementById('ckeditorCom');
        let parent = document.getElementById('now-version');
        parent.scrollTo(0, target.offsetTop - parent.offsetTop);
      },50)
    },
    //点赞知识
    likeKnowledge(){
      let url = requestUrl.comment.likeKnowledge + this.knowledgeDetail.knowledgeId;
      this.$http.put(url).then(res => {
        console.log('res',res)
        if (res.data.code == 0){
          if (this.comment.like){
            this.$message({
              message:this.$t('versionManage.cancelLike'),
              duration:2000,
              type:'success'
            })
          } else {
            this.$message({
              message:this.$t('versionManage.like'),
              duration:2000,
              type:'success'
            })
          }
        }
        this.getKnowledgeLikeList();
      })
    },
    getKnowledgeLikeList(){
      let url = requestUrl.comment.likeKnowledgeList + this.knowledgeDetail.knowledgeId;
      this.$http.get(url).then(res => {
        if (res.data.code == 0 && res.data.data){
          this.comment.likeNumber = res.data.data.likeCount;
          this.comment.likeList = res.data.data.likes;
          this.comment.like = res.data.data.like
        }
      })
    },
    observerFun(){
      // const option = {
      //   threshold:1.0,
      //   root:document.querySelector('#KnowledgePreview')
      // }
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          console.log('entry',entry.isIntersecting)
          if (entry.isIntersecting){
            this.goTop = true;
          } else {
            this.goTop = false;
          }
        });
      });
      let div = document.getElementById('reviewContainer')
      this.observer.observe(div);
    },
    scrollView(){
      let target = document.getElementById('reviewContainer');
      let parent = document.getElementById('now-version');
      if (this.goTop){
        parent.scrollTo(0, 0);
      } else {
        parent.scrollTo(0, target.offsetTop - parent.offsetTop);
      }
    },
    //加载更多二级评论
    loadMore(item,parentCommentId){
      console.log('loadMore',item,parentCommentId)
      this.replyPageIndex[parentCommentId] += 1;
      this.getCommentList(parentCommentId);
    },
    //加载更多评论
    loadMoreComment(){
      this.pageIndex += 1;
      this.getCommentList();
    },
    getClientUser(){
      let url = "/knowledge-api/sso/auth/client-user";
      this.$http.get(url).then(res => {
        console.log('getClientUser',res)
        if (res.data.code == 0 && res.data.data){
          this.clientUser = res.data.data
        }
      })
    },
    closeSummary(){
      this.showSummary = false;
      this.$emit('closeSummary')
    },
    getImg(event, htmlContent) {
      if (event.target.localName === 'img') {
        this.imgList = []
        let richtext = htmlContent
        this.imgList = [];
        richtext.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
          this.imgList.push(capture);
        });
        /*当前点击的图片作为第一个图片*/
        let index = this.imgList.indexOf(event.target.currentSrc);
        if (index !== -1) {
          this.imgList.splice(index, 1);
        }
        this.imgList.unshift(event.target.currentSrc);
        this.previewImage = true;
      }
    },
    closeViewer() {
      this.previewImage = false;
    },
  },
  watch: {
    knowledgeDetail: {
      handler() {
        console.log('[KnowledgePreview] watch knowledgeDetail triggered. fileType:', this.fileType, 'isConversationRecord:', this.isConversationRecord);
        console.log('[KnowledgePreview] knowledgeDetail.thirdExt:', this.knowledgeDetail && this.knowledgeDetail.thirdExt);
        // 如果父组件未提供 thirdExt，则尝试补齐
        if (!this.knowledgeDetail || !this.knowledgeDetail.thirdExt) {
          this.fetchThirdExtIfMissing();
        }
        if (this.fileType === 'TXT' && this.isConversationRecord) {
          this.prepareConversationAudios();
        } else {
          this.signedAudioUrls = [];
          this.audioUrls = [];
        }
      },
      deep: false
    },
    fileType() {
      console.log('[KnowledgePreview] watch fileType. fileType:', this.fileType, 'isConversationRecord:', this.isConversationRecord);
      if (!this.effectiveThirdExt) {
        this.fetchThirdExtIfMissing();
      }
      if (this.fileType === 'TXT' && this.isConversationRecord) {
        this.prepareConversationAudios();
      } else {
        this.signedAudioUrls = [];
        this.audioUrls = [];
      }
    }
  },
  mounted() {
    this.documentId = this.$route.query.id;
    this.getCommentList();
    this.getKnowledgeLikeList();
    this.getClientUser()
    this.$nextTick(() => {
      this.observerFun();
    })
    console.log('[KnowledgePreview] mounted. fileType:', this.fileType);
    console.log('[KnowledgePreview] knowledgeDetail:', this.knowledgeDetail);
    console.log('[KnowledgePreview] thirdExt:', this.knowledgeDetail && this.knowledgeDetail.thirdExt);
    if (!this.knowledgeDetail || !this.knowledgeDetail.thirdExt) {
      this.fetchThirdExtIfMissing();
    }
    console.log('[KnowledgePreview] isConversationRecord:', this.isConversationRecord);
    // 若是对话记录并为TXT预览，准备音频签名
    if (this.fileType === 'TXT' && this.isConversationRecord) {
      console.log('[KnowledgePreview] condition matched: show audio block and sign.');
      this.prepareConversationAudios();
    } else {
      console.log('[KnowledgePreview] condition not matched. show? ', 'fileType===TXT:', this.fileType === 'TXT', 'isConversationRecord:', this.isConversationRecord);
    }
    // 若是音频文件，获取 html_result 内容
    if (this.isAudioFile) {
      console.log('[KnowledgePreview] isAudioFile, loading html content');
      this.getAudioHtmlContent();
    }
  }
};
</script>

<style scoped lang="less">
#KnowledgePreview{
  //height: calc(100% - 41px);
  //height: 100%;
  //overflow-y: scroll;
  scroll-behavior: smooth;
  //overflow: hidden;
  max-width: 820px;
  margin: 0 auto;
  padding: 0 20px;
  
  // 音频预览容器样式
  .audio-preview-container{
    // width: 100%;
    // padding: 20px 0;
    // display: flex;
    // flex-direction: column;
    // align-items: center;
    // min-height: 300px;
    
    .audio-player-wrapper{
      // width: 100%;
      // max-width: 700px;
      background: #f8f9fc;
      border-radius: 12px;
      padding: 30px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
      margin-bottom: 30px;
      
      .audio-info{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #e0e6f7;
        
        .audio-icon{
          font-size: 24px;
          color: #366aff;
          margin-right: 12px;
        }
        
        .audio-name{
          font-size: 16px;
          font-weight: 500;
          color: #333;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      
      .audio-player{
        width: 100%;
        outline: none;
        
        &::-webkit-media-controls-panel{
          background-color: #fff;
        }
      }
    }
    
    .audio-text-content{
      // width: 100%;
      // max-width: 700px;
      background: #fff;
      border-radius: 8px;
      padding: 24px;
      box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05);
      line-height: 1.8;
      color: #333;
      font-size: 14px;
      
      /deep/p{
        margin-bottom: 12px;
      }
      
      /deep/h1, /deep/h2, /deep/h3{
        margin-top: 20px;
        margin-bottom: 12px;
        font-weight: 600;
      }
      
      /deep/img{
        max-width: 100%;
      }
    }
  }
  .reviewContainer{
    //padding-right: 10px;
    margin-top: 20px;
    .noOneLikeStatus{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .likeBtn{
        flex: none;
        width: 43px;
        height: 43px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        cursor: pointer;
        i{
          color: #ffffff;
          font-size: 26px;
        }
      }
      .likeText{
        text-align: center;
        position: relative;

        &::after {
          position: absolute;
          top: 52%;
          content: '';
          width: 40%;
          height: 1px;
          right: -55px;
        }

        &::before {
          position: absolute;
          left: -55px;
          top: 52%;
          content: '';
          width: 40%;
          height: 1px;
        }
      }
      .likeTextEn{
        &::after{
          right: -90px;
        }
        &::before{
          left: -90px;
        }
      }
    }
    .likeStatus1{
      .likeBtn{
        background: #D2DEFF;
      }
      .likeText{
        color: #366AFF;
        &::after{
          background-color: #D6DFFF;
        }
        &::before{
          background-color: #D6DFFF;
        }
      }
    }
    .likeStatus2{
      .likeBtn{
        background: #E1E6ED;
      }
      .likeText{
        color: #A9B3C6;
        &::after{
          background-color: #E6EDFF;
        }
        &::before{
          background-color: #E6EDFF;
        }
      }
    }
    .likeList{
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      .likeItem{
        flex: none;
        width: 26px;
        height: 26px;
        background: #366AFF;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        margin-right: 6px;
        font-size: 12px;
      }
      /deep/.el-avatar{
        margin-right: 6px;
      }
    }
    .commentList{
      margin-top: 10px;
      .header{
        font-size: 18px;
        color: #1f2329;
        font-weight: 500;
        padding-bottom: 12px;
        border-bottom: 1px solid #E0E6F7;
        font-family: "Microsoft YaHei";
      }
      .setReplayItemBorder{
        border: 1px dashed #E0E6F7;
      }
      .loadMoreComment{
        margin: 20px 0;
        padding-left: 10px;
        color: #366aff;
        cursor: pointer;
      }
    }
  }
  .floating{
    height: 36px;
    width: 36px;
    position: absolute;
    cursor: pointer;
    z-index: 61;
    bottom: 20px;
    .ksCOFC{
      height: 36px;
      width: 36px;
      border: 1px solid #dee0e3;
      border-radius: 50%;
      box-shadow: 0px 0px 18px 0px rgba(29, 55, 129, 0.07);
      background-color: #ffffff;
      pointer-events: all;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .floating-1{
    right: 60px;
  }
  .floating-2{
    right: 450px;
  }
}
.xlsKnowledgeHeight{
  height: 100%;
  /deep/.file_pre{
    height: 80% !important;
    background-color: #ffffff;
    border-radius: 5px;
  }
}
.conversation-audio{
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 12px 12px 6px;
  margin-bottom: 12px;
  .audio-header{
    font-size: 14px;
    color: #1f2329;
    margin-bottom: 8px;
    font-weight: 500;
  }
  .audio-list{
    display: flex;
    flex-direction: column;
    gap: 8px;
    .audio-item{
      display: flex;
      align-items: center;
      gap: 10px;
      .audio-label{
        color: #606266;
        font-size: 12px;
        width: 56px;
        text-align: right;
      }
      audio{ width: 100%; }
    }
  }
}
</style>
